<div class="mb-4">
	<div class="p-grid">
		<div class="p-col-3">
			{{ payment.paymentType }}
		</div>
		<div class="p-col-6">
			{{ payment.datacapAuthorization.TranResponse.AcctNo }}
		</div>
		<div class="p-col-3">
			{{ payment.amount | currency }}
		</div>
	</div>
	<div class="text-italics ms-2" *ngIf="!detailView" (click)="detailView = true">View Details</div>
	<div class="text-italics ms-2" *ngIf="detailView" (click)="detailView = false">Hide Details</div>
	<div *ngIf="detailView" class="ms-4 w-100">
		<ng-container *ngFor="let line of payment.datacapAuthorization.PrintDataStringArray">
			<div class="ms-2">
				{{ line }}
			</div>
		</ng-container>
	</div>
</div>
